export const notificationOfDriversLicenseSuspensions = (date?: string) => {
  return [
    { text: 'Notification of Drivers License Suspensions', style: 'h1' },

    { text: "§ 383.33 Notification of driver's license suspensions :", bold: true, margin: [0, 10, 0, 10] },

    { text: "Each employee who has a driver's license suspended, revoked, or canceled by a State or jurisdiction, who loses the right to operate a commercial motor vehicle in a State or jurisdiction for any period, or who is disqualified from operating a commercial motor vehicle for any period, shall notify his/her current employer of such suspension, revocation, cancellation, lost privilege, or disqualification. The notification must be made before the end of the business day following the day the employee received notice of the suspension, revocation, cancellation, lost privilege, or disqualification.", style: 'p', margin: [20, 10, 0, 20] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};